import {
  useLocationSearch,
  useNavigate,
  useParams,
} from '@rocketlane/rocket-router';
import { useEffect } from 'react';
import styled from 'styled-components';
import { Loading } from 'components/atoms/loading';
import { API_KEY } from 'services';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100;
`;

export const AddApiKey: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { apiKey } = useParams<{ apiKey: string }>();
  const search = useLocationSearch();
  const history = useNavigate();

  useEffect(() => {
    localStorage.setItem(
      API_KEY,
      JSON.stringify(['api_key', apiKey, 37620, 113363]),
    );

    const searchParams = new URLSearchParams(search);

    const target = searchParams.get('target');
    const domain = searchParams.get('domain');
    const clearedPath = target?.replaceAll(
      `/add-api-key/${apiKey}/?domain=${domain}&`,
      '',
    );

    if (Boolean(apiKey) === true) {
      if (clearedPath !== undefined && clearedPath.length > 0) {
        history(
          { pathname: `${clearedPath}` },
          {
            replace: true,
          },
        );
      }
    }
  }, [apiKey, search, history]);

  return (
    <StyledDiv>
      <Loading />
    </StyledDiv>
  );
};
